import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=3e60b4c6&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=3e60b4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60b4c6",
  null
  
)

export default component.exports